import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CaseListingInstanceState } from 'app/area/case-report/case-listing/types-store';
import { RenderMode } from 'app/types-shared';
import { TileProps } from 'ui/tile/tile';
import { createSelector } from 'reselect';

const getComponentDescriptorProperties = (
  _: CaseState | CaseListingInstanceState, uiEngineProps: ConnectedComponentProps
) => uiEngineProps.componentDescriptor.properties;

const getRenderMode = (state: CaseState | CaseListingInstanceState) => state.renderMode;

const getEnabledEntityOperations = (
  _: CaseState | CaseListingInstanceState, uiEngineProps: ConnectedComponentProps
) => uiEngineProps.enabledEntityOperations;

export const editDocumentItemVisibility = createSelector(
  [getComponentDescriptorProperties, getRenderMode, getEnabledEntityOperations],
  (properties, renderMode, enabledEntityOperations): Partial<TileProps> => {
    const { showDetailsEditButton } = properties;

    return {
      showDetailsEditButton:
        enabledEntityOperations &&
        enabledEntityOperations.edit &&
        showDetailsEditButton &&
        renderMode === RenderMode.read
    };
  }
);
